import { z } from "zod";

export const CACHE_VERSION = 1;
export const CACHE_DB_IDENTIFIER = "mem/cache-v2";
export const CACHE_TABLE_IDENTIFIER = "cache";

export enum CacheKey {
  ActiveClientInfo = "ACTIVE_CLIENT_INFO",
  MyAccount = "MY_ACCOUNT",
  MySpaces = "MY_SPACES",
  MySpaceAccounts = "MY_SPACE_ACCOUNTS",
  FeatureGateConfigs = "FEATURE_GATE_CONFIGS",
  ImportSessionsInProgress = "IMPORT_SESSIONS_IN_PROGRESS",
}

export const ActiveClientInfo = z.object({
  clientGroupId: z.string().uuid(),
});

export const MyAccountCacheSchema = z.object({
  id: z.string().uuid(),
  profileEmailAddress: z.string(),
  profileDisplayName: z.string(),
  profilePhotoUrl: z.string().nullable(),
  settings: z.record(z.unknown()).optional(),
});

export const MySpacesCacheSchema = z.array(
  z.object({
    id: z.string().uuid(),
    title: z.string(),
  })
);

export const MySpaceAccountsCacheSchema = z.array(
  z.object({
    id: z.string().uuid(),
    spaceId: z.string().uuid(),
    accountId: z.string().uuid(),
    profileEmailAddress: z.string(),
    profileDisplayName: z.string(),
    profilePhotoUrl: z.string().nullable(),
  })
);

export const FeatureGateConfigDataSchema = z.object({
  period: z.string(),
  limits: z.object({
    free: z.number().nullable(),
    paid: z.number().nullable(),
  }),
});

export const FeatureGateConfigsCacheSchema = z.record(z.string(), FeatureGateConfigDataSchema);

export const ImportSessionsInProgressCacheSchema = z.array(
  z.object({
    sessionId: z.string().uuid(),
    createdAtMs: z.number(),
  })
);

export const CACHE_SCHEMA = {
  [CacheKey.ActiveClientInfo]: ActiveClientInfo,
  [CacheKey.MyAccount]: MyAccountCacheSchema,
  [CacheKey.MySpaces]: MySpacesCacheSchema,
  [CacheKey.MySpaceAccounts]: MySpaceAccountsCacheSchema,
  [CacheKey.FeatureGateConfigs]: FeatureGateConfigsCacheSchema,
  [CacheKey.ImportSessionsInProgress]: ImportSessionsInProgressCacheSchema,
};

/**
 * Mapping of CacheKey to the type of the data that is stored
 */
export type CacheSchemaType = {
  [K in CacheKey]: z.infer<(typeof CACHE_SCHEMA)[K]>;
};
